import React, { useState } from 'react';
import { FileTextIcon, UsersIcon, TruckIcon, FileCheckIcon } from 'lucide-react';
import { QuoteStepHeader } from '../shared/QuoteStepHeader';
import { QuoteStepNavigation } from '../shared/QuoteStepNavigation';
import { PivotSelectionStep } from './PivotSelectionStep';
import { CustomerInfoStep } from '../shared/CustomerInfoStep';
import { ShippingTermsStep } from '../shared/ShippingTermsStep';
import { QuoteReviewStep } from '../shared/QuoteReviewStep';
export function PivotQuoteFlow({
  initialData = null
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const [quoteData, setQuoteData] = useState({
    pivots: initialData?.pivots || [],
    customerInfo: initialData?.customerInfo || {},
    shipping: initialData?.shipping || {},
    // Preservar otros datos importantes si estamos editando
    ...(initialData && {
      id: initialData.id,
      quoteNumber: initialData.quoteNumber,
      date: initialData.date,
      status: initialData.status,
      expiryDate: initialData.expiryDate,
      quotedBy: initialData.quotedBy,
      type: 'Pivot'
    })
  });
  const steps = [{
    label: 'Pivots',
    icon: <FileTextIcon size={16} data-id="element-4337" data-mp="2z3jy32ia3sx" />
  }, {
    label: 'Customer Info',
    icon: <UsersIcon size={16} data-id="element-4338" data-mp="gpp2trrymdqt" />
  }, {
    label: 'Shipping & Terms',
    icon: <TruckIcon size={16} data-id="element-4339" data-mp="bxf7txbzmnho" />
  }, {
    label: 'Review',
    icon: <FileCheckIcon size={16} data-id="element-4340" data-mp="bvuc44dxsyi8" />
  }];
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      // Submit quote
      console.log('Submit quote', quoteData);
    }
  };
  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  const handleSave = () => {
    console.log('Save draft', quoteData);
  };
  const updateQuoteData = (section, data) => {
    setQuoteData({
      ...quoteData,
      [section]: data
    });
  };
  return <div className="bg-slate-800/30 rounded-xl border border-blue-800/30 p-6" data-id="element-4341" data-mp="2wgl4kdhagajv">
      <QuoteStepHeader steps={steps} currentStep={currentStep} onChangeStep={setCurrentStep} data-id="element-4342" data-mp="10cwutg0m93va" />
      <div className="mt-8" data-id="element-4343" data-mp="15bqc7jj0xf0q">
        {currentStep === 0 && <PivotSelectionStep initialData={quoteData.pivots} onUpdate={data => updateQuoteData('pivots', data)} data-id="element-4344" data-mp="15c9tcy0unzdp" />}
        {currentStep === 1 && <CustomerInfoStep initialData={quoteData.customerInfo} onUpdate={data => updateQuoteData('customerInfo', data)} data-id="element-4345" data-mp="1ad7973ye0hc1" />}
        {currentStep === 2 && <ShippingTermsStep initialData={quoteData.shipping} onUpdate={data => updateQuoteData('shipping', data)} data-id="element-4346" data-mp="1jahm0tqusej2" />}
        {currentStep === 3 && <QuoteReviewStep quoteData={quoteData} quoteType="Pivot" data-id="element-4347" data-mp="1o8j3594py3rw" />}
      </div>
      <QuoteStepNavigation currentStep={currentStep} totalSteps={steps.length} onNext={handleNext} onBack={handleBack} onSave={handleSave} isFinalStep={currentStep === steps.length - 1} data-id="element-4348" data-mp="1t1udvlcnj4p3" />
    </div>;
}